export class ActivitiesModel {
  public student_id: string;
  public group_time_slot: string;
  public activity_date: any;
  public activity_start_time: number;
  public activity_end_time: number;
  public activity_duration: string;
  public activity_type: string;
  public activity_objective: string;
  public activity_remarks: string;
  public mentor: string;
  public document: string;
  public document_type: string;
  public document_name: string;
  public academic_year: string;
  public contact_means: string;

  public activity_files: ActivitiesFile[] = [];
  public group_files: ActivitiesFile[] = [];
}

export class ActivitiesFile {
  public file: string;
  public type: string;
  public remarks: string;
}



// WEBPACK FOOTER //
// ./src/app/application/web-components/student/activities.model.ts